import styles from './ContentSlider.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { isSearchResultsPath } from '@seek/seek-jobs-seo';
import classnames from 'classnames';

const PANELS = [
  'dashboard', 'refinebar', 'searchbar'
];

const mapStateToProps = () => createSelector(
  state => state.dashboard.expand,
  state => state.location.isHomepage,
  state => state.location.pathname,
  state => state.search.activeRefinement,

  (dashboardExpand, isHomepage, pathname, activeRefinement) => ({
    dashboardExpand,
    isHomepage,
    pathname,
    activeRefinement
  })
);
@connect(mapStateToProps)
export default class ContentSlider extends Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
    trigger: PropTypes.oneOfType([
      PropTypes.oneOf(PANELS),
      PropTypes.arrayOf(
        PropTypes.oneOf(PANELS)
      )
    ]).isRequired,
    dashboardExpand: PropTypes.bool.isRequired,
    isHomepage: PropTypes.bool.isRequired,
    pathname: PropTypes.string.isRequired,
    activeRefinement: PropTypes.string
  };

  shouldSlide(triggerName, condition) {
    const { trigger } = this.props;

    return (triggerName === trigger || trigger.indexOf(triggerName) > -1) && condition;
  }

  render() {
    const {
      children,
      dashboardExpand,
      isHomepage,
      pathname,
      activeRefinement
    } = this.props;

    const isSearchPage = isSearchResultsPath(pathname);
    const dashboardIsOpen = dashboardExpand && isHomepage;
    const worktypeIsOpen = isSearchPage && activeRefinement === 'WorkType';
    const salaryIsOpen = isSearchPage && (activeRefinement === 'SalaryFrom' || activeRefinement === 'SalaryTo');
    const datelistedIsOpen = isSearchPage && activeRefinement === 'DateListed';
    const searchbarIsExpanded = isHomepage;
    const searchbarIsCollapsed = isSearchPage;

    const className = classnames({
      [styles.root]: true,
      [styles.dashboard_isOpen]: this.shouldSlide('dashboard', dashboardIsOpen),
      [styles.worktype_isOpen]: this.shouldSlide('refinebar', worktypeIsOpen),
      [styles.salary_isOpen]: this.shouldSlide('refinebar', salaryIsOpen),
      [styles.datelisted_isOpen]: this.shouldSlide('refinebar', datelistedIsOpen),
      [styles.searchbar_isExpanded]: this.shouldSlide('searchbar', searchbarIsExpanded),
      [styles.searchbar_isCollapsed]: this.shouldSlide('searchbar', searchbarIsCollapsed)
    });

    return (
      <div className={className}>
        { children }
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/ContentSlider/ContentSlider.js
 **/